export function getHost(): string {
  // return "http://localhost:5000/api/v1";
  // return "https://vtrading.biz/api/v1";
  return "https://www.tradingplane.com/api/v1";
}
// redeploy
